export default {
  closeModal: "Close login window",
  enterLearningWorld: "Enter the world of learning",
  confirmMobile: "Confirm Mobile Number",
  enterMobileDescription: "Enter your mobile number to receive a verification code.",
  enterCodeDescription: "Enter the code sent to",
  mobileLabel: "Mobile Number",
  mobilePlaceholder: "0912 123 4567",
  sendingOtp: "Sending...",
  sendOtpBtn: "Send verification code",
  verifyingOtp: "Verifying...",
  verifyOtpBtn: "Confirm and Login",
  editMobile: "Edit Number",
  resendTimer: "Resend in",
  resendCode: "Resend code",
  secureInfo: "Your information is secure with us."
};
